<template>
  <div class="layout">
    <el-header @getNav='getNav'></el-header>
    <!-- <breadcrumb></breadcrumb> -->
    <breadcrumbs></breadcrumbs>
    <div class="content">
      <keep-alive include="workOrder">
        <router-view></router-view>
      </keep-alive>
    </div>
    <div class="nav">
      <!-- <left-nav></left-nav> -->
      <!-- <basicNav v-if="$route.path.search('basic')!==-1"></basicNav>
      <orderNav v-if="$route.path.search('order')!==-1"></orderNav>
      <stockNav v-if="$route.path.search('stock')!==-1"></stockNav> -->
      <siderBar></siderBar>
    </div>
    <div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import elHeader from '@/components/layout/header'
import siderBar from '@/components/layout/SiderBar'
import leftNav from '@/components/layout/leftnav/leftNav'
// import basicNav from '@/components/layout/leftnav/basicNav'
// import orderNav from '@/components/layout/leftnav/orderNav'
// import stockNav from '@/components/layout/leftnav/stockNav'
import breadcrumb from '@/components/common/breadcrumb/breadcrumb'
import breadcrumbs from '@/components/common/breadcrumb'
export default {
  components: { elHeader, leftNav, breadcrumb, siderBar, breadcrumbs },
  data () {
    return {
    }
  },
  methods: {
    // getBreadCrumbList (val) {
    //   this.breadCrumbList = []
    //   for (let i of val) {
    //     this.breadCrumbList.push(i.name)
    //   }
    // },
    getNav (val) {
      this.navIndex = val
    }
  }
}
</script>
<style lang="scss" scoped>
.layout {
  position: relative;
  // margin-left: 211.88px;
  right: 0;
  .content {
    position: fixed;
    overflow-y: auto;
    top: 30px;
    right: 0;
    left: 0;
    bottom: 0px;
    border-radius: 10px;
    margin: 50px 16px 0 186px;
    background-color: #fff;
    padding: 0px 10px 10px 10px;
    z-index: 2;
  }

}
.nav {
  position: fixed;
  left: 0;
  top: 48px;
  bottom: 0;
  background-color: #303a43;
  width: 170px;
  z-index: 2;
  height: calc(100vh - 48px);
  overflow-y: auto;
  &::-webkit-scrollbar{
    width: 7px;
    height: 7px;
    background-color: #F5F5F5;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  /*定义滑块 内阴影+圆角*/
  &::-webkit-scrollbar-thumb{
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
    background-color: #c8c8c8;
  }
  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
}

</style>



// WEBPACK FOOTER //
// src/components/layout/layout.vue